import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { handleAPI } from '../../../utils/api/api';

const initialState = {
  upsellMappers: [],
  isLoading: true,
  error: null,
  totalPage: null,
  totalCount: null,
};

export const getUpsellMappers = createAsyncThunk('upsell/getUpsellMappers', async (params) => {
  const response = await handleAPI('platform/upsell_gateway_mappers', 'get', params);
  return response;
});

const upsellMapperSlice = createSlice({
  name: 'upsell',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getUpsellMappers.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUpsellMappers.fulfilled, (state, action) => {
      state.isLoading = false;
      state.upsellMappers = action.payload;
      state.totalPage = action?.metaData?.total_pages;
      state.totalCount = action?.metaData?.total_count;
    });
    builder.addCase(getUpsellMappers.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default upsellMapperSlice.reducer;
